import { useMemo } from 'react'
import { getCountForm } from '@ucheba/utils/helpers/number'
import { IProfessionsListItemProps, IUseProfessionsListItemCore } from './types'
import { professionPath } from './contants'

export const useProfessionHref = (id: IProfessionsListItemProps['id']): string => {
  return useMemo(() => `${professionPath}/${id}`, [id])
}

export const useImageColWidth = (width: string): string => {
  return useMemo(() => `${parseInt(width, 10) + 32}px`, [width])
}

export const useProfessionsListItemCore: IUseProfessionsListItemCore = (props) => {
  const { collageCount, vuzCount, tagIds, courseCount, specialityIds } = props

  const institutions = useMemo(() => {
    if (vuzCount === 0) return null
    if (typeof vuzCount === 'number') {
      return {
        entity: vuzCount,
        clarification: getCountForm(vuzCount, ['вуз', 'вуза', 'вузов']),
      }
    }

    return null
  }, [vuzCount])

  const collages = useMemo(() => {
    if (collageCount === 0) return null
    if (typeof collageCount === 'number') {
      return {
        entity: collageCount,
        clarification: getCountForm(collageCount, ['колледж', 'колледжа', 'колледжей']),
      }
    }

    return null
  }, [collageCount])

  const courses = useMemo(() => {
    if (courseCount === 0) return null
    if (typeof courseCount === 'number') {
      return {
        entity: courseCount,
        clarification: getCountForm(courseCount, ['курс', 'курса', 'курсов']),
      }
    }

    return null
  }, [courseCount])

  const hrefVuzs = useMemo(() => {
    if (!specialityIds) return `/for-abiturients/vuz`

    const specialityIdsStr = specialityIds
      ?.map((id, key) => {
        const paramName = encodeURIComponent(`eq[${key}]`)
        const paramValue = encodeURIComponent(`__sp:${id}`)

        return `${paramName}=${paramValue}`
      })
      .join('&')
    return `/for-abiturients/vuz?${specialityIdsStr}`
  }, [specialityIds])

  const hrefCollage = useMemo(() => {
    if (!specialityIds) return `/for-abiturients/college`

    const specialityIdsStr = specialityIds
      ?.map((id, key) => {
        const paramName = encodeURIComponent(`eq[${key}]`)
        const paramValue = encodeURIComponent(`__sp:${id}`)
        return `${paramName}=${paramValue}`
      })
      .join('&')

    return `/for-abiturients/college?${specialityIdsStr}`
  }, [tagIds])

  const hrefCourse = useMemo(() => {
    if (!tagIds) return `/for-specialists/courses`

    const tagIdsStr = tagIds
      ?.map((id, key) => {
        const paramName = encodeURIComponent(`eq[${key}]`)
        const paramValue = encodeURIComponent(`__t:${id}`)

        return `${paramName}=${paramValue}`
      })
      .join('&')

    return `/for-specialists/courses?${tagIdsStr}`
  }, [tagIds])

  return {
    institutions,
    collages,
    hrefVuzs,
    hrefCollage,
    courses,
    hrefCourse,
  }
}
